import { render, staticRenderFns } from "./Modal-remark.vue?vue&type=template&id=df79abf2&scoped=true"
import script from "./Modal-remark.vue?vue&type=script&lang=js"
export * from "./Modal-remark.vue?vue&type=script&lang=js"
import style0 from "./Modal-remark.vue?vue&type=style&index=0&id=df79abf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df79abf2",
  null
  
)

export default component.exports